import { useMutation } from '@tanstack/react-query';
import type { LoginInput } from '@booknest/shared';

import { useAuthStore } from '../store/authStore.js';
import { authApi } from '../api/auth.api.js';

export function useLogin() {
  const setSession = useAuthStore((s) => s.setSession);
  return useMutation({
    mutationFn: (input: LoginInput) => authApi.login(input),
    onSuccess: (data) => {
      setSession({ user: data.user, accessToken: data.tokens.accessToken });
    },
  });
}
